export default "__VITE_ASSET__c2c93e16__"